<template>
<div class="chapter">
<div class="inner_page">
<h1>Acknowledgments</h1>
<p class="sectiontop">Many thanks to Marsha Briscoe, a long-time supporter of my work, and to Judy Lipp, LCSW, for sharing her experience as a mental health professional working with patients who suffer from more than mental illness.</p>
<p>My great appreciation goes to Stanley Hilton, native San Franciscan and author, who provided much of the “flavor” of the City by the Bay for this book.</p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<blockquote>
<p class="sectiontop" style="text-align: center;">To Eve, Sybil, Truddi, and others who share their bodies with more than one personality.</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?987f46d2